<template>
  <div :style="containerStyle">
    <BaseCollapse :collapseWidth="collapseWidth"
                  @collapse="$emit('collapse')"
                  @open="$emit('open')">
      <template v-slot:collapse>
        <div />
      </template>
      <template v-slot:open>
        <HeaderSmallSecondary>
          USER PREFERENCE
        </HeaderSmallSecondary>
        <div v-for="(option, index) in options.user" :key="option.label"
             :style="optionContainerStyle"
             @click="selectOption(index)">
          <SideMenuItem :content="option.content"
                        :selected="$route.name === option.to.name">
            {{ option.text }}
          </SideMenuItem>
        </div>
        <template v-if="isAdmin">
          <HeaderSmallSecondary :style="headerSmallStyle">
            ADMIN
          </HeaderSmallSecondary>
          <div v-for="(option, index) in options.admin" :key="option.label"
               :style="optionContainerStyle"
               @click="selectAdminOption(index)">
            <SideMenuItem :content="option.content"
                          :selected="$route.name === option.to.name">
              {{ option.text }}
            </SideMenuItem>
          </div>
        </template>
      </template>
    </BaseCollapse>
  </div>
</template>

<script>
  import BaseCollapse from '@base/base-collapse'
  import HeaderSmallSecondary from '@modules/text/header-small-secondary'
  import SideMenuItem from '@settings/modules/side-menu-item'
  import { FontStyle } from '@js/styles'
  import { mapGetters } from 'vuex'
  import { MIN_WIDTHS } from '@js/constants'

  export default {
    name: 'SideMenu',
    components: {
      BaseCollapse,
      HeaderSmallSecondary,
      SideMenuItem,
    },
    props: {
      options: { type: Object, required: true },
    },
    data: function () {
      return {
        collapseWidth: MIN_WIDTHS.LARGE,
        containerStyle: {
          position: 'relative',
        },
        headerSmallStyle: {
          marginTop: '32px',
        },
        optionContainerStyle: {
          cursor: 'pointer',
          marginTop: '16px',
        },
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      ...mapGetters('tenantUser', ['isAdmin']),
    },
    methods: {
      goTo: function (name) {
        if (this.$route.name !== name) {
          this.$router.push({ name: name });
        }
      },
      selectOption: function (index) {
        this.goTo(this.options.user[index].to.name);
      },
      selectAdminOption: function (index) {
        this.goTo(this.options.admin[index].to.name);
      },
    },
  };
</script>
